import React, { useRef } from "react";
import { LanguageSelector } from "../../../../../components";
import { AppBar, CircularProgress, Fab, Grid, Toolbar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AdminEditFormHandler } from "../AdminEditFormHandler";
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import clsx from "clsx";
import { green } from '@material-ui/core/colors';
const useStyles = makeStyles(theme => ({
    head: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    wrapper: {
        margin: theme.spacing(1),
        position: 'relative',
    },
    fabProgress: {
        color: green[500],
        position: 'absolute',
        top: -6,
        left: -6,
        zIndex: 1,
    },
}));
export const AdminEditHeader = ({ title, form, languageSelector = false, buttonRef = useRef(), children }) => {
    const { formState: { isSubmitting, isSubmitSuccessful, isDirty } } = form;
    const style = useStyles();
    return React.createElement(Grid, { item: true },
        React.createElement(AdminEditFormHandler, { form: form }),
        React.createElement(AppBar, { position: "static", color: "default", className: style.head },
            React.createElement(Toolbar, null,
                React.createElement(Grid, { container: true, justifyContent: "space-between", alignItems: "center" },
                    React.createElement(Typography, { component: "h1", variant: "h3" }, title),
                    children,
                    React.createElement(Grid, { item: true },
                        React.createElement(Grid, { container: true },
                            languageSelector && React.createElement(LanguageSelector, Object.assign({}, {})),
                            React.createElement("div", { className: style.wrapper },
                                React.createElement(Fab, { type: "submit", color: "primary", className: clsx({
                                        [style.buttonSuccess]: (isSubmitSuccessful && !isDirty),
                                    }), disabled: isSubmitting, ref: buttonRef }, (isSubmitSuccessful && !isDirty) ? React.createElement(CheckIcon, null) : React.createElement(SaveIcon, null)),
                                isSubmitting && React.createElement(CircularProgress, { size: 68, className: style.fabProgress }))))))));
};
//# sourceMappingURL=index.js.map